import React, { Component } from 'react';
import style from './Intro.module.scss';
import SlideLoader from '../../ui/SlideLoader';
import LogoSVG from '../LogoSVG';
import HSSLogo from '../../../assets/hss_logo_final.png';
import { TweenLite, Ease } from 'gsap';

class HSSLogoSlide extends Component {
  state = { loaded: false };

  handleLoad = () => {
    this.setState({ loaded: true });
  };

  render() {
    return (
      <div className={`${style.introSlide} ${style.hssSlide} `}>
        <img
          src={HSSLogo}
          alt="Hentry Street Settlement"
          className={`${style.hssLogo} ${
            this.state.loaded ? style.loaded : ''
          }  `}
          onLoad={this.handleLoad}
        />
        <p>{this.props.text}</p>
      </div>
    );
  }
}

// const HSSLogoSlide = props => (
//   <div className={`${style.introSlide} ${style.hssSlide}`}>
//     <img
//       src={HSSLogo}
//       alt="Hentry Street Settlement"
//       className={style.hssLogo}
//     />
//     <p>{props.text}</p>
//   </div>
// );

const LogoTypeSlide = () => (
  <div className={`${style.introSlide} ${style.logotypeSlide}`}>
    {/* <p>
      <strong>Explore</strong> the <strong>story</strong> of
    </p> */}
    <div className={style.logotypeWrap}>
      <LogoSVG logoColor="white" width="100%" height="100%" />
    </div>
    <p>
      An Online Exhibition, Timeline, Neighborhood Tour, <br />
      and High School Curriculum about the{' '}
      <strong>
        birth of <br /> Henry Street Settlement{' '}
      </strong>
      and the <strong>power of taking action</strong>.
    </p>
  </div>
);

const SLIDETIME = [3000, 6000];

const BIG_PADDING = { t: 95, lr: 40, b: 95 };

const SMALL_PADDING = { t: 60, lr: 20, b: 65 };
class Intro extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.PADDING = window.innerWidth > 768 ? BIG_PADDING : SMALL_PADDING;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const widthPercent = (windowWidth - this.PADDING.lr * 2) / windowWidth;
      const heightPercent =
        (windowHeight - (this.PADDING.t + this.PADDING.b)) / windowHeight;

      TweenLite.set(this.containerEl, {
        width: `${widthPercent * 100}%`,
        height: `${heightPercent * 100}%`,
        scaleX: 1 / widthPercent,
        scaleY: 1 / heightPercent,
        x: `${this.PADDING.lr}px`,
        y: `${this.PADDING.t}px`,
      });

      TweenLite.set(this.slidesRef, {
        scaleX: 1 * widthPercent,
        scaleY: 1 * heightPercent,
      });

      this.slidesRef;

      const scaleScaleFactor = 1.1;
      const fromScaleFactor = 1.6;
      const toScaleFactor = 1.25;

      TweenLite.fromTo(
        this.imgFrame,
        9,
        {
          scaleX: widthPercent * (fromScaleFactor * scaleScaleFactor),
          scaleY: heightPercent * (fromScaleFactor * scaleScaleFactor),
          ease: Quad.easeOut,
        },
        {
          scaleX: widthPercent * (toScaleFactor * scaleScaleFactor),
          scaleY: heightPercent * (toScaleFactor * scaleScaleFactor),
          ease: Quad.easeOut,
        }
      );
    });
  }
  handleIntroComplete = () => {
    if (
      this.props.location.pathname === '' ||
      this.props.location.pathname === '/'
    ) {
      // shrink to match home hero, fpo-ish for now
      // these sizes match the styling of the home slide
      const delay = 0.15;
      const duration = 1.5;
      TweenLite.to(this.containerEl, duration, {
        y: this.PADDING.t,
        scaleX: 1,
        scaleY: 1,
        delay: delay,
        ease: Quad.easeInOut,
        onComplete: this.props.onIntroComplete,
      });

      TweenLite.to(this.imgFrame, duration, {
        scaleX: 1,
        scaleY: 1,
        ease: Quad.easeInOut,
        delay: delay,
      });
    } else {
      // just fade out
      TweenLite.to(this.containerEl, 1, {
        opacity: 0,
        delay: 1,
        onComplete: this.props.onIntroComplete,
      });
    }
  };
  getRef = el => {
    this.bkRef = el;
  };

  getFrameRef = el => {
    this.imgFrame = el;
  };

  getSlidesRef = el => {
    this.slidesRef = el;
  };

  render() {
    return (
      <div
        className={style.intro}
        ref={el => {
          this.containerEl = el;
        }}
      >
        <div className={style.introFrame}>
          <SlideLoader
            getRef={this.getFrameRef}
            getSlidesRef={this.getSlidesRef}
            slideTime={SLIDETIME}
            slides={[
              <HSSLogoSlide text={this.props.text} />,
              <LogoTypeSlide />,
            ]}
            onComplete={this.handleIntroComplete}
            bk={{
              src: this.props.image,
              opacity: 0.5,
            }}
          />
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/global/intro/index.js